import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UsedSgkz011aService } from './used-sgkz011a.service';
import { TimeApiService } from './time-api.service';
import { SystemErrorDataService } from '../components/sgkz002d/services/system-error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UsedSgkz012aService } from './used-sgkz012d.service';
import { LoginUserIdService } from './login-user-id.service';

/**
 * MainComponent用 初期データ取得用サービス
 * @example
 * ログイン中の画面更新時、URL直打ち時に使用
 * MainComponent作成前に呼び出される
 * ※app-routing.module.tsで設定
 * 
 * @export
 * @class InitialInfoResolverService
 */
@Injectable({
  providedIn: 'root'
})
export class InitialInfoResolverService {

  constructor(private router: Router,
    private systemErrorDataService: SystemErrorDataService,
    private timeApiService: TimeApiService,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSgkz012aService: UsedSgkz012aService,
    private loginUserIdService: LoginUserIdService) { }

  /**
   * 初期データ取得用メソッド
   * 
   * ユーザ情報取得のみ同期処理
   * ※インターセプト処理でリクエストカスタマイズエリアにユーザ情報を登録するため
   */
  async resolve(): Promise<void> {

    try {
      // ユーザ情報取得のみ同期処理
      // インターセプト処理でリクエストカスタマイズエリアにユーザ情報を登録するため
      if (!this.usedSgkz011aService.isCalledFlag) {
        await this.usedSgkz011aService.updateUserInfo();
      }

      // 業務日付取得
      if (!this.timeApiService.isCalledFlag) {
        this.timeApiService.updateBussinessDate();
      }

      let userId = '';
      this.loginUserIdService.loginUserId.subscribe(loginUserId => {
        userId = loginUserId;
      });

      // 組織兼務情報取得
      if (!this.usedSgkz012aService.isCalledFlag && userId !== '') {
        this.usedSgkz012aService.updateSoshikiKenmuInfo();
      }

      return;
    } catch (error) {

      // ユーザ情報取得 または 業務日付取得にて業務エラー発生時
      // 後続処理不可のため、システムエラー画面に遷移
      // 業務エラーと500エラーでシステムエラー画面に表示するメッセージが違うため分岐している
      if (error instanceof HttpErrorResponse && error.status >= 500 && 599 >= error.status) {
        this.router.navigate(['/sgkz002d']);

      // kcis-authが組織兼務の場合、401エラーを返却するため
      } else if (error instanceof HttpErrorResponse && error.status === 401) {
        this.router.navigate(['/sgkz007d']);

      } else {
        this.systemErrorDataService.systemErrorData = {
          messageId: '',
          message: error.message,
          errorDetail: '',
        }

        this.router.navigate(['/sgkz002d']);
      }

      return;
    }
  }
}
